import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from 'react-bootstrap';
import { HotKeys } from 'react-hotkeys';

export function StdModalDialog(props) {
    const keyMap = {
        save: ['enter'],
    };

    const handlers = {
        save: () => props.onSave({
            target: { value: props.id },
            currentTarget: { value: props.id },
        }),
    };

    return (

        <Modal
            backdrop="static"
            autoFocus={false}
            size="lg"
            show={props.isOpen}
            containter={props.container}
            onHide={props.hideHandler}
            aria-labelledby="contained-modal-title"
        >
            <Modal.Header closeButton>

                <Modal.Title>{props.title}</Modal.Title>

            </Modal.Header>
            <Modal.Body>
                <HotKeys keyMap={!props.hotkeysDisabled && keyMap} handlers={handlers}>
                    {props.body}
                </HotKeys>
            </Modal.Body>
            <Modal.Footer>
                {props.footer}

                <Button variant="outline-primary" onClick={props.hideHandler}>
                    {' '}
                    <FontAwesomeIcon icon="times" />
                    {' '}
                    Закрыть
                </Button>
                <Button value={props.id} variant="success" onClick={props.onSave}>
                    {' '}
                    <FontAwesomeIcon
                        icon="check"
                    />
                    {' '}
                    Сохранить
                </Button>
            </Modal.Footer>
        </Modal>

    );
}
